﻿import {
	HamburgerMenuComponent,
	Log,
} from '../../shared/tsjs/shared-modules.bundle.js';

document.addEventListener('DOMContentLoaded', () => {
	Log.info('Main layout script loaded');
	HamburgerMenuComponent.setup();
});
